import moment from 'moment'

export class User {
  constructor () {
    this.athlete = {
      id: undefined,
      name: undefined,
      email: undefined,
      gender: undefined,
      sessionsPerWeek: undefined, // integer
      trainingPrograms: undefined, // list of program codes
      weight: undefined,
      waist: undefined,
      registrationDate: undefined,
      isFirstLogin: undefined,
      bodyLog: [],
      records: {},
      nextSessions: {},
      recordLog: {},
      progSeqNum: 0,
      week: undefined,
      forceSessionRefresh: true, // by default refresh the session list
      recordsInit: false,
      gotoNextSessions: false
    }
    this.id = function () {
      return this.athlete.id
    }
    this.getUsername = function () {
      return this.athlete.email
    }
    this.setUsername = function (username) {
      this.athlete.email = username
    }
    this.load = function (data) {
      this.athlete = {...this.athlete, ...data}
      return this
    }
    this.loads = function (str) {
      return this.load(JSON.parse(str))
    }
    this.dump = function () {
      return this.athlete
    }
    this.dumps = function () {
      return JSON.stringify(this.dump())
    }
    this.bodyFat = function (weight, waist) {
      var bf = 0
      if (this.athlete.gender === 'male') {
        bf = (-98.42 + (4.15 * waist / 2.54) - (0.082 * weight * 2.2)) / (weight * 2.2)
      } else {
        bf = (-76.76 + (4.15 * waist / 2.54) - (0.082 * weight * 2.2)) / (weight * 2.2)
      }
      return (bf * 100).toFixed(1)
    }
    this.addBodyChange = function (body) {
      var log = {
        dt: moment(),
        weight: body.weight,
        waist: body.waist
      }
      if (this.athlete.bodyLog) {
        this.athlete.bodyLog.push(log)
      } else {
        this.athlete.bodyLog = [log]
      }
    }
    this.addRecord = function (record) {
      // if it is the first record, init the log array
      if (!this.athlete.recordLog[record.skill]) this.athlete.recordLog[record.skill] = []
      // add the record to the log
      record.dt = moment() // set the record date
      // if type is time, compute the value as # of seconds
      if (record.unit === 'time') {
        record.value = (record.valueMinutes * 60 + record.valueSeconds) / 60 // decimal representation of minutes
        record.valueText = record.valueMinutes + "'" + record.valueSeconds + "''"
      }
      this.athlete.recordLog[record.skill].push(record)
      // update the current record
      this.athlete.records[record.skill] = record
    }
    this.getRecord = function (skill, percentage = 1.0, defaultVal) {
      var record = this.athlete.records[skill]
      if (record) {
        if (record.unit === 'time') {
          return Math.round(percentage * (record.valueMinutes * 60 + record.valueSeconds))
        } else {
          return Math.round(record.value * percentage)
        }
      } else if (defaultVal) {
        return defaultVal
      } else {
        return ' - '
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/models.js